import React from "react";
import styled from "styled-components";
import Helper from "../../libs/helper";

import Button from "./button";

const parse = require("html-react-parser");

const Casa = styled.div`
  margin-top: 32px;
`;

const Title = styled.div`
  font-family: "Basteleur";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 125%;
  padding: 16px 0px;
  color: #e96159;
`;

const Description = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #737373;
  margin-bottom: 30px;
`;

// const Capacity = styled.div`
//   font-family: "Inter";
//   font-style: normal;
//   font-weight: 400;
//   font-size: 16px;
//   line-height: 150%;
//   color: #737373;
//   padding: 16px 0px;
// `;

const PriceHolder = styled.div`
  font-family: "Inter";
  text-align: right;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #e96159;
`;

const Price = styled.span`
  display: block;
  float: right;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
  background: #e96159;
  padding: 4px 20px;
  border-radius: 19px;
  margin-left: 10px;
  margin-top: -4px;
`;

const ButtonHolder = styled.div`
  margin-top: 16px;
  border-bottom: 1px solid #e96159;
  background: #ffffff;
`;

const Clear = styled.div`
  clear: both;
`;

export default function PacoteItem({ pacote, callback }) {
  let helper = Helper();

  return (
    <Casa>
      <img
        src={pacote.photo}
        alt={pacote.name}
        style={{ width: "100%", borderRadius: 8 }}
      />
      <Title>
        {pacote.name} ({helper.stringToDate(pacote.start).getDate()}/
        {helper.stringToDate(pacote.start).getMonth() + 1} -{" "}
        {helper.stringToDate(pacote.end).getDate()}/
        {helper.stringToDate(pacote.end).getMonth() + 1})
      </Title>
      <Description>
        {parse(pacote.description ? pacote.description : "")}
      </Description>
      {/* <Capacity>👥 Capacidade máxima: {casa.capacity} pessoas</Capacity> */}
      <PriceHolder>
        A partir de <Price>{helper.floatToMoney(pacote.min_price)}</Price>
        <Clear></Clear>
      </PriceHolder>
      <ButtonHolder>
        <Button
          callback={() => {
            callback(pacote);
          }}
          inverted={true}
        >
          QUERO RESERVAR
        </Button>
      </ButtonHolder>
    </Casa>
  );
}
